import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSavedFilterCount as GetSavedFilterCountQuery,
    GetSavedFilterCount_savedFilterCount as SavedFilterCount,
    GetSavedFilterCountVariables,
} from 'nutshell-graphql-types';

import GET_SAVED_FILTER_COUNT from '../queries/get-saved-filter-count.graphql';

export const useGetSavedFilterCount = (
    url?: string | null
): {
    savedFilterCount: SavedFilterCount | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetSavedFilterCountQuery,
        GetSavedFilterCountVariables
    >(GET_SAVED_FILTER_COUNT, {
        variables: {
            url: url || '',
        },
        skip: !url,
    });

    return {
        savedFilterCount: data && data.savedFilterCount,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
